<template>
    <v-card
      dark
      class="primary darken-1"
      height="327"
      :width="width"
      :min-width="minWidth"
      :style="
        environmentalRestriction ? 'border-radius: 5px; overflow-y: auto' : ''
      "
    >
      <v-expand-transition>
        <div
          v-if="environmentalRestriction"
          class="d-flex transition-fast-in-fast-out primary darken-1 v-card--reveal"
        >
          <v-card-text class="secondary--text text--lighten-1 text-justify">
            <v-row>
              <v-col cols="6">
                <v-icon
                  large
                  color="secondary lighten-1"
                  @click="toggleEnvironmentalRestriction"
                  >mdi-arrow-left-circle</v-icon
                >
              </v-col>
              <v-spacer />
              <v-col cols="6" align-self="end" align="end">
                <v-icon large color="secondary lighten-1"
                  >$environmentalRestrictions</v-icon
                >
              </v-col>
            </v-row>
            <br />
            <p>
              <span>
                As restrições ambientais no estado do Paraná e,
                consequentemente, nas bacias hidrográficas monitoradas
                correspondem a:</span
              >
            </p>
            <ul>
              <li>
                Assentamentos: Delimitação dos Assentamentos da Reforma Agrária,
                baseado na Norma de Execução DT nº 69/2008 (fonte: INCRA, 2020);
              </li>
              <li>
                Áreas Prioritárias para Conservação da Biodiversidade:
                Delimitação de áreas prioritárias para conservação da
                biodiversidade da Mata Atlântica com base no Decreto n° 5.092 de
                21 de maio de 2004 (fonte: MMA, 2020); Reservas Particulares do
                Patrimônio Natural (RRPNs) Federais: Áreas delimitadas na
                modalidade de Unidade de Conservação de domínio privado (pessoa
                física ou jurídica) com o objetivo de conservação da diversidade
                biológica (fonte: ICMBio, 2021);
              </li>

              <li>
                Unidades de Conservação Estadual: Áreas delimitadas na
                modalidade de Unidade de Conservação de Proteção Integral ou de
                Uso Sustentável, fundamentado na Lei n° 9.985, de 18 de julho de
                2000 (fonte: IAT, 2021);
              </li>
              <li>
                Unidades de Conservação Federal: Áreas delimitadas na modalidade
                de Unidade de Conservação de Proteção Integral ou de Uso
                Sustentável, fundamentado na Lei n° 9.985, de 18 de julho de
                2000 (fonte: ICMBio, 2022);
              </li>
              <li>
                Terras Indígenas: Delimitação de áreas tradicionalmente ocupadas
                pelos povos indígenas, conforme Decreto n° 5.051, de 19 de abril
                de 2004 (fonte: FUNAI, 2021).
              </li>
            </ul>
          </v-card-text>
        </div>
      </v-expand-transition>
      <div v-if="!environmentalRestriction">
        <v-card-subtitle class="white--text text--white">
          <span class="textDate"
            ><v-icon small>restore</v-icon> atualizado em</span
          ><br />
          <span class="textDate">{{restrictionData[this.restrictionData.length - 1].params.data_dado}}</span>
        </v-card-subtitle>
        <v-card-title>
          <v-icon class="ml-n1" color="secondary lighten-1" large>
            $environmentalRestrictions
          </v-icon>
        </v-card-title>
        <v-card-subtitle class="white--text text--white">
          <strong class="textTitle">Restrições Ambientais</strong>
          <v-tooltip right color="#1A232F">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                style="z-index: 999"
                class="ml-1"
                color="secondary lighten-1"
                v-bind="attrs"
                v-on="on"
                @click="toggleEnvironmentalRestriction"
              >
                help_outline
              </v-icon>
            </template>
            <span>Clique para informações</span>
          </v-tooltip>
        </v-card-subtitle>
        <v-card-text class="white--text text--white">
          <v-row dense>
            <v-col cols="12">
              <CardEnvironmentalRestrictionsChart
                class="mt-n13"
                :location="location">
              </CardEnvironmentalRestrictionsChart>
            </v-col>
          </v-row>
        </v-card-text>
      </div>
    </v-card>
</template>

  <script>
import CardEnvironmentalRestrictionsChart from "@/components/indicators/IndicatorsCardsItems/CardEnvironmentalRestrictionsChart";
import { mapGetters } from 'vuex';
export default {
  name: "CardEnvironmentalRestrictions",
  props: {
    minWidth: {
      required: false,
    },
    location: {
      required: true,
    },
    width: {
      required: false,
    }
  },
  components: { CardEnvironmentalRestrictionsChart },
  data() {
    return {
      environmentalRestriction: false,
    };
  },
  computed: {
    ...mapGetters(['restrictionData']),
  },
  methods: {
    toggleEnvironmentalRestriction() {
      this.environmentalRestriction = !this.environmentalRestriction;
    },
  },
};
</script>

<style scoped>
.textDate {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
}
.textTitle {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
}
/* width */
::-webkit-scrollbar {
  width: 7px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: darkgrey;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey;
}
</style>
